import {useIntl} from 'react-intl'
import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import ItemForm from '../component/New'
import {useNavigate} from 'react-router-dom'

export default function ItemsNew() {
  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-5 align-items-center'>
        <button
          className='btn btn-primary btn-sm'
          onClick={() => {
            navigate('/items')
          }}
        >
          <i className='fa fa-arrow-left'></i>
        </button>
        <BreadCrumb currentPage={intl.formatMessage({id: 'ITEMS.ADD'})} />
      </div>

      <div id='kt_app_content_container' className='d-flex flex-column flex-root mt-10'>
        <ItemForm />
      </div>
    </>
  )
}
